// extracted by css-extract-rspack-plugin
export default {"skeleton":"skeleton___q6GsM7Vg","skeleton-pulse":"skeleton-pulse___GHk94zFL"};